export default {
  name: 'zh-cn',
  const: {
    'MENU_MODE': {
      'side': '侧边栏模式',
      'head': '顶部模式',
      'head-side': '顶部+侧边栏模式',
    }
  },
  components: {
    notFound: '抱歉，你访问的页面不存在。',
  },
};
